/* ARTD design concepts: shared kit.
   Real Shopify cart (AJAX), slide-out bag, quick add, card swatches,
   product-page variant picking, mobile menus. Each concept styles it with its own CSS. */
(function () {
  'use strict';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var FREE_SHIP = 3000; /* cents: free US shipping from $30 = the "Free Standard Shipping" rate in Printify's US zone (Shopify shipping settings) */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function sized(src, w) {
    if (!src) return '';
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var cart = {
    get: function () {
      return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    add: function (id, qty, props) {
      var item = { id: +id, quantity: qty || 1 };
      if (props && Object.keys(props).length) item.properties = props;
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [item] })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    addMany: function (list) {
      return fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: list.slice().reverse().map(function (x) { var o = { id: +x.id, quantity: x.qty || 1 }; if (x.props) o.properties = x.props; return o; }) })
      }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
    },
    change: function (key, qty) {
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function (r) { return r.json(); });
    }
  };

  /* ---------- the bag (cart drawer) ---------- */
  var drawer = $('[data-cx-cart]');
  var view = (new URLSearchParams(location.search)).get('view') || '';
  /* only the design-concept previews (?view=club...) carry ?view= along on every link;
     other alternate templates (e.g. the family page, ?view=family) must not leak into the menu links */
  var cview = /^(concepts|club|boutique|fitting)$/.test(view) ? view : '';

  /* colour name -> swatch hex (keep in sync with snippets/cx-hex.liquid) */
  var HEX = {
    'white': '#ffffff', 'natural': '#efe5cf', 'soft cream': '#efe5cf', 'cream': '#efe5cf',
    'pink': '#f7c6d2', 'light pink': '#f7c6d2', 'heather columbia blue': '#a7c5e3', 'light blue': '#a7c5e3', 'baby blue': '#a7c5e3',
    'gold': '#f4b740', 'yellow': '#f4b740', 'heather mauve': '#b5899a', 'kelly': '#1d9a57', 'kelly green': '#1d9a57',
    'heather team purple': '#6b5597', 'asphalt': '#545659', 'dark grey heather': '#4a4a4d', 'dark heather': '#4a4a4d', 'charcoal': '#4a4a4d',
    'athletic heather': '#c3c3c5', 'heather grey': '#c3c3c5', 'sport grey': '#c3c3c5', 'berry': '#b42e64', 'team purple': '#4d2b80', 'purple': '#4d2b80',
    'heather navy': '#3a4462', 'true royal': '#2453ad', 'royal': '#2453ad', 'forest': '#1f3c2e', 'forest green': '#1f3c2e', 'maroon': '#5a1d2b',
    'navy': '#1c2541', 'vintage black': '#2f2f32', 'black': '#151515', 'red': '#c72330', 'orange': '#f0772d', 'mint': '#a8e2c8', 'lavender': '#c6b6e6'
  };
  /* "Style" = which tee the shopper picked it as (Max, Oct 9 2026: the bag, checkout and order email say "Girls' tee",
     "Boys' tee", "Women's tee" or "Men's tee"). It rides along as a line item property, so Shopify shows
     "Style: Women's tee" at checkout and in emails. Set from the page's side (?see= / a grid's data-cx-see). */
  var STYLE = { her: 'Women’s tee', him: 'Men’s tee', girl: 'Girls’ tee', boy: 'Boys’ tee' };
  function styleProps(see) { return STYLE[see] ? { Style: STYLE[see] } : null; }
  function whoLabel(w, f) {
    if (w === 'toddler') return 'Toddler tee';
    if (w === 'adult') return f === 'women' ? 'Women\u2019s tee' : f === 'men' ? 'Men\u2019s tee' : 'Adult tee';
    return 'Kids\u2019 tee';
  }
  /* friendly name + who it's for: from the page's product list, else guessed from the title/type */
  function itemInfo(it) {
    var known = (window.CX_PRODUCTS || {})[it.handle];
    if (known) return known;
    var tl = ((it.product_title || '') + ' ' + (it.product_type || '')).toLowerCase();
    return {
      n: (it.product_title || '').split(/\s[\u2013\u2014|-]\s/)[0],
      w: /toddler|baby/.test(tl) ? 'toddler' : /youth|kid/.test(tl) ? 'kids' : 'adult',
      f: /women/.test(tl) ? 'women' : /\bmen/.test(tl) ? 'men' : 'unisex'
    };
  }
  function lineHTML(it) {
    var info = itemInfo(it);
    var opts = it.options_with_values || [];
    var color = (opts.find(function (o) { return /colou?r/i.test(o.name); }) || {}).value;
    var size = (opts.find(function (o) { return /size/i.test(o.name); }) || {}).value;
    var forWho = it.properties && it.properties.For;
    var hex = color ? (HEX[String(color).toLowerCase()] || '#d9d4cf') : null;
    var url = cview ? it.url + (it.url.indexOf('?') > -1 ? '&' : '?') + 'view=' + encodeURIComponent(cview) : it.url;
    return '<div class="cx-line" data-key="' + esc(it.key) + '">' +
      '<a class="cx-line__img" href="' + esc(url) + '"><img src="' + esc(sized(it.image, 240)) + '" alt="" width="120" height="120"></a>' +
      '<div class="cx-line__info">' +
        '<div class="cx-line__top"><a class="cx-line__name" href="' + esc(url) + '">' + esc(info.n) + '</a><b class="cx-line__price">' + money(it.final_line_price) + '</b></div>' +
        '<span class="cx-line__who">' + esc((it.properties && it.properties.Style) || whoLabel(info.w, info.f)) + (forWho ? ' \u00b7 <em>For ' + esc(forWho) + '</em>' : '') + '</span>' +
        '<span class="cx-line__opts">' +
          (color ? '<i style="--c:' + hex + '" aria-hidden="true"></i>' + esc(color) : '') +
          (color && size ? '<span class="cx-line__sep" aria-hidden="true"></span>' : '') +
          (size ? 'Size <b>' + esc(size) + '</b>' : '') +
        '</span>' +
        '<div class="cx-line__row">' +
          '<div class="cx-qty" role="group" aria-label="Quantity">' +
            '<button type="button" data-cx-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="One less">&minus;</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-cx-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="One more">+</button>' +
          '</div>' +
          '<button type="button" class="cx-line__remove" data-cx-remove="' + esc(it.key) + '" aria-label="Remove ' + esc(info.n) + ' from bag">' +
            '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13M10 11v6M14 11v6"/></svg>Remove' +
          '</button>' +
        '</div>' +
      '</div>' +
    '</div>';
  }

  function render(c) {
    $$('[data-cx-count]').forEach(function (el) { el.textContent = c.item_count; el.classList.toggle('is-zero', !c.item_count); });
    if (!drawer) return;
    var items = $('[data-cx-items]', drawer);
    items.innerHTML = c.item_count
      ? c.items.map(lineHTML).join('')
      : '<div class="cx-cart__empty"><p class="cx-cart__empty-title">Your bag is empty</p><p>Every cat is printed just for you once you order.</p><button type="button" class="cx-btn" data-cx-cart-close>Keep browsing</button></div>';
    var left = FREE_SHIP - c.total_price;
    var ship = $('[data-cx-ship]', drawer);
    if (ship) {
      ship.innerHTML = c.item_count
        ? '<p>' + (left > 0 ? 'You’re <b>' + money(left) + '</b> away from free US shipping' : '<b>You’ve unlocked free US shipping!</b>') + '</p>' +
          '<div class="cx-ship__bar"><span style="width:' + Math.min(100, Math.round(c.total_price / FREE_SHIP * 100)) + '%"></span></div>'
        : '';
    }
    $('[data-cx-total]', drawer).textContent = money(c.total_price);
    var bc = $('[data-cx-bagcount]', drawer);
    if (bc) bc.textContent = c.item_count ? c.item_count + (c.item_count === 1 ? ' item' : ' items') : '';
    drawer.classList.toggle('is-empty', !c.item_count);
  }

  var lastFocus = null;
  function openCart() {
    if (!drawer) { location.href = root + 'cart'; return; }
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(function () { requestAnimationFrame(function () { drawer.classList.add('is-open'); }); });
    document.documentElement.classList.add('cx-lock');
    var close = $('.cx-cart__x', drawer); if (close) close.focus({ preventScroll: true });
  }
  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    document.documentElement.classList.remove('cx-lock');
    setTimeout(function () { if (!drawer.classList.contains('is-open')) drawer.hidden = true; }, 380);
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  function refresh() { return cart.get().then(render); }

  function addAndOpen(id, qty, btn, props) {
    if (!id) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    return cart.add(id, qty, props)
      .then(refresh)
      .then(openCart)
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that one could not be added.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = label; } });
  }

  function toast(msg) {
    var t = $('.cx-toast') || document.body.appendChild(Object.assign(document.createElement('div'), { className: 'cx-toast', role: 'status' }));
    t.textContent = msg;
    t.classList.add('is-on');
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove('is-on'); }, 3200);
  }

  /* ---------- quick add from product cards ----------
     <article data-cx-card data-color="White"> ... <div data-cx-quick='[[colour, size, variantId, available], ...]'>
     with buttons data-cx-qsize="S". Sizes not made in the card's current colour are disabled. */
  function quickMap(card) {
    var q = card && $('[data-cx-quick]', card);
    if (!q) return null;
    if (!q._map) { try { q._map = JSON.parse(q.getAttribute('data-cx-quick')); } catch (err) { q._map = []; } }
    return q._map;
  }
  function quickFind(card, size) {
    var map = quickMap(card); if (!map) return null;
    var col = card.getAttribute('data-color');
    return map.find(function (r) { return (r[0] === col || r[0] === null) && r[1] === size; }) || null;
  }
  function quickSync(card) {
    if (!quickMap(card)) return;
    $$('[data-cx-qsize]', card).forEach(function (b) {
      var hit = quickFind(card, b.getAttribute('data-cx-qsize'));
      b.disabled = !(hit && hit[3]);
    });
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cx-cart-open]')) { e.preventDefault(); refresh(); openCart(); return; }
    if (t.closest('[data-cx-cart-close]')) { e.preventDefault(); closeCart(); return; }

    var rm = t.closest('[data-cx-remove]');
    if (rm) {
      e.preventDefault();
      var line = rm.closest('.cx-line'); if (line) line.classList.add('is-removing');
      rm.disabled = true;
      cart.change(rm.getAttribute('data-cx-remove'), 0).then(render);
      return;
    }

    var q = t.closest('[data-cx-qty]');
    if (q) { e.preventDefault(); cart.change(q.getAttribute('data-cx-qty'), +q.getAttribute('data-q')).then(render); return; }

    var sw = t.closest('[data-cx-sw]');
    if (sw) {
      e.preventDefault();
      var card = sw.closest('[data-cx-card]');
      if (!card) return;
      pickColor(card, sw);
      var alt = $('[data-cx-img-alt]', card), alt2 = sw.getAttribute('data-img-alt');
      if (alt && alt2) alt.src = alt2;
      var name = $('[data-cx-sw-name]', card); if (name) name.textContent = sw.getAttribute('title') || '';
      return;
    }

    var qs = t.closest('[data-cx-qsize]');
    if (qs) {
      e.preventDefault();
      var qcard = qs.closest('[data-cx-card]');
      var hit = quickFind(qcard, qs.getAttribute('data-cx-qsize'));
      if (hit && hit[3]) addAndOpen(hit[2], 1, qs, styleProps(seeOf(qcard)));
      else toast('Sorry, that size is sold out in this colour.');
      return;
    }

    var add = t.closest('[data-cx-add]');
    if (add) { e.preventDefault(); addAndOpen(add.getAttribute('data-cx-add'), 1, add); return; }

    var cp = t.closest('[data-cx-copy]');
    if (cp) {
      e.preventDefault();
      var txt = cp.getAttribute('data-cx-copy'), done = function () { var o = cp.textContent; cp.textContent = 'Copied!'; setTimeout(function () { cp.textContent = o; }, 1800); };
      if (navigator.clipboard) navigator.clipboard.writeText(txt).then(done, function () { toast('Your code: ' + txt); });
      else toast('Your code: ' + txt);
      return;
    }

    var tog = t.closest('[data-cx-toggle]');
    if (tog) {
      e.preventDefault();
      var target = document.getElementById(tog.getAttribute('data-cx-toggle'));
      if (!target) return;
      var on = !target.classList.contains('is-open');
      target.classList.toggle('is-open', on);
      tog.setAttribute('aria-expanded', on ? 'true' : 'false');
      document.documentElement.classList.toggle('cx-lock', on && target.hasAttribute('data-cx-lock'));
      return;
    }
  });

  /* mouse only: hovering a colour dot previews that colour on its card; leaving the dots
     brings back the chosen colour (the pressed dot). Clicking still chooses. */
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    document.addEventListener('mouseover', function (e) {
      var sw = e.target.closest && e.target.closest('[data-cx-sw]');
      if (!sw) return;
      var card = sw.closest('[data-cx-card]'), im = card && $('[data-cx-img]', card), src = srcFor(sw, '');
      if (im && src && im.getAttribute('src') !== src) { im.src = src; im.removeAttribute('srcset'); }
    });
    document.addEventListener('mouseout', function (e) {
      var grp = e.target.closest && e.target.closest('[data-cx-card] [role="group"]');
      if (!grp || (e.relatedTarget && grp.contains(e.relatedTarget))) return;
      paintCard(grp.closest('[data-cx-card]'));
    });
  }

  /* ---------- who the shopper is shopping for (Oct 7-8 2026) ----------
     A grid (or any parent) with data-cx-see="girl|boy|her|him" gives every card's links ?see=..., so the product page
     shows only that person's photos (Max, Oct 8: the shop grid always shows the plain shirts; the people are on the
     product page). Cards keep showing the flat tee of their colour. */
  var SEEKEY = { girl: 'g', boy: 'b', her: 'w', him: 'm' };
  function seeOf(card) { var g = card && card.closest('[data-cx-see]'); return g ? g.getAttribute('data-cx-see') : ''; }
  function srcFor(el, see) {
    var k = SEEKEY[see];
    return (k && el.getAttribute('data-' + k)) || el.getAttribute('data-f') || el.getAttribute('data-img') || '';
  }
  function setLink(a, base, see) {
    try {
      var u = new URL(base || a.href, location.href);
      if (see) u.searchParams.set('see', see); else u.searchParams.delete('see');
      a.href = u.pathname + u.search + u.hash;
    } catch (err) { }
  }
  function paintCard(card) {
    if (!card) return;
    var see = seeOf(card), im = $('[data-cx-img]', card);
    var on = $('[data-cx-sw][aria-pressed="true"]', card) || im;
    if (im && on) {
      var src = srcFor(on, '');
      if (src && im.getAttribute('src') !== src) { im.src = src; im.removeAttribute('srcset'); }
      var name = (card.querySelector('.cc-card__name a') || {}).textContent || '';
      var col = card.getAttribute('data-color') || '';
      im.alt = name + ' tee' + (col ? ' in ' + col : '');
    }
    $$('a[data-cx-link]', card).forEach(function (a) { setLink(a, null, SEEKEY[see] ? see : ''); });
  }
  /* choose a colour on a card (dot click, colour filter). A dot hidden behind "+N" moves to the front. */
  function pickColor(card, sw) {
    var grp = sw.parentNode;
    if (grp && getComputedStyle(sw).display === 'none') grp.insertBefore(sw, grp.firstChild);
    $$('[data-cx-sw]', card).forEach(function (s) { s.setAttribute('aria-pressed', s === sw ? 'true' : 'false'); });
    card.setAttribute('data-color', sw.getAttribute('title') || '');
    var link = sw.getAttribute('data-href');
    if (link) $$('a[data-cx-link]', card).forEach(function (a) { a.href = link; });
    paintCard(card);
    quickSync(card);
  }
  function see(rootEl, view) {
    if (!rootEl) return;
    if (view) rootEl.setAttribute('data-cx-see', view); else rootEl.removeAttribute('data-cx-see');
    $$('[data-cx-card]', rootEl).forEach(paintCard);
  }
  /* choose a colour by name on a card; false when the card doesn't come in it */
  function cardColor(card, colorName) {
    var want = String(colorName || '').toLowerCase();
    var sw = $$('[data-cx-sw]', card).find(function (s) { return (s.getAttribute('title') || '').toLowerCase() === want; });
    if (!sw) return false;
    if (sw.getAttribute('aria-pressed') !== 'true') pickColor(card, sw);
    return true;
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (drawer && drawer.classList.contains('is-open')) closeCart();
    $$('[data-cx-lock].is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.documentElement.classList.remove('cx-lock');
  });

  /* product forms anywhere: <form data-cx-form> with name="id" (+ optional name="quantity") */
  document.addEventListener('submit', function (e) {
    var f = e.target.closest && e.target.closest('form[data-cx-form]');
    if (!f) return;
    e.preventDefault();
    var id = (f.querySelector('[name="id"]') || {}).value;
    var qty = +((f.querySelector('[name="quantity"]') || {}).value) || 1;
    /* line item properties in the form (properties[Style] on the product page); blank ones are left out */
    var props = {};
    $$('[name^="properties["]', f).forEach(function (i) { if (i.value) props[i.name.slice(11, -1)] = i.value; });
    addAndOpen(id, qty, f.querySelector('[type="submit"]'), props);
  });

  /* ---------- variant picker (product pages + fitting room) ----------
     data = { options: ['Size','Color'], variants: [{id, options:[..], available, price}] }
     Inputs: radios with data-cx-opt="<option index>". Calls onChange(variant, picked[]). */
  function picker(rootEl, data, onChange) {
    var colorIdx = data.options.findIndex(function (n) { return /colou?r/i.test(n); });
    function picked() {
      return data.options.map(function (n, i) {
        var r = rootEl.querySelector('input[data-cx-opt="' + i + '"]:checked');
        return r ? r.value : null;
      });
    }
    function find(vals) {
      return data.variants.find(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); });
    }
    function sync(changedIdx) {
      var vals = picked();
      var v = find(vals);
      /* colour changed and this size isn't made / in stock in it: snap to the nearest size that is */
      if ((!v || !v.available) && colorIdx > -1) {
        var keep = changedIdx === colorIdx ? colorIdx : changedIdx;
        var alt = data.variants.find(function (x) { return x.available && x.options[keep] === vals[keep] && (colorIdx === keep || x.options[colorIdx] === vals[colorIdx]); });
        if (alt) {
          alt.options.forEach(function (o, i) {
            var r = rootEl.querySelector('input[data-cx-opt="' + i + '"][value="' + CSS.escape(o) + '"]');
            if (r) r.checked = true;
          });
          vals = picked(); v = find(vals);
        }
      }
      /* grey out sizes that aren't available in the chosen colour */
      if (colorIdx > -1) {
        data.options.forEach(function (n, i) {
          if (i === colorIdx) return;
          $$('input[data-cx-opt="' + i + '"]', rootEl).forEach(function (r) {
            var ok = data.variants.some(function (x) { return x.available && x.options[i] === r.value && x.options[colorIdx] === vals[colorIdx]; });
            r.closest('label') && r.closest('label').classList.toggle('is-out', !ok);
          });
        });
      }
      data.options.forEach(function (n, i) {
        $$('[data-cx-opt-value="' + i + '"]', rootEl).forEach(function (el) { el.textContent = vals[i] || ''; });
      });
      var idIn = rootEl.querySelector('[name="id"]'); if (idIn && v) idIn.value = v.id;
      var btn = rootEl.querySelector('[data-cx-buy]');
      if (btn) {
        btn.disabled = !v || !v.available;
        var lbl = btn.querySelector('[data-cx-buy-label]') || btn;
        lbl.textContent = !v ? 'Unavailable' : v.available ? (btn.getAttribute('data-label') || 'Add to bag') : 'Sold out';
      }
      $$('[data-cx-price]', rootEl).forEach(function (el) { if (v) el.textContent = money(v.price); });
      if (onChange) onChange(v, vals, colorIdx);
    }
    rootEl.addEventListener('change', function (e) {
      var i = e.target.getAttribute && e.target.getAttribute('data-cx-opt');
      if (i !== null && i !== undefined) sync(+i);
    });
    sync(colorIdx);
    return { sync: sync, picked: picked, colorIdx: colorIdx };
  }

  function addManyAndOpen(list, btn) {
    if (!list || !list.length) return;
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    return cart.addMany(list)
      .then(refresh)
      .then(openCart)
      .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, those could not be added.'); })
      .then(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); btn.innerHTML = label; } });
  }

  /* One colour's photos as { flat, girl, boy } using the product's photo pattern (see cx-look).
     For adults the two model photos are labelled her / him. */
  function photos(p, colorName) {
    var c = (p.colors || []).find(function (x) { return x.name === colorName; }) || (p.colors || [])[0];
    var out = { flat: null, girl: null, boy: null, her: [], him: [], worn: [] };
    if (!c) return out;
    var list = [c.flat].concat(c.poses || []);
    var pat = p.pattern || 'fgb';
    if (c.kinds) {
      /* known photos: kinds lists each photo (f flat, g girl, b boy, w on her, m on him, p worn) */
      out.flat = list[c.kinds.indexOf('f')] || null;
      out.girl = list[c.kinds.indexOf('g')] || null;
      out.boy = list[c.kinds.indexOf('b')] || null;
      c.kinds.split('').forEach(function (k, i) {
        if (!list[i]) return;
        if (k === 'w') out.her.push(list[i]);
        else if (k === 'm') out.him.push(list[i]);
        else if (k === 'p') out.worn.push(list[i]);
      });
      if (!out.flat) out.flat = out.girl || out.her[0] || out.him[0] || list[0];
      return out;
    }
    if (pat === 'gbf') { out.girl = list[0] || null; out.boy = list[1] || null; out.flat = list[2] || null; }
    else if (pat === 'g') { out.girl = list[0] || null; }
    else if (pat === 'f') { out.flat = list[0] || null; }
    else { out.flat = list[0] || null; out.girl = list[1] || null; out.boy = list[2] || null; }
    if (p.card && p.card.color === c.name) {
      if (p.card.a) out.flat = p.card.a;
      if (p.card.b && !out.girl && p.card.b !== out.flat) out.girl = p.card.b;
    }
    if (!out.flat) out.flat = out.girl || list[0];
    if (out.girl === out.flat) out.girl = null;
    return out;
  }
  function modelLabels(who) { return who === 'adult' ? ['On her', 'On him'] : ['On a girl', 'On a boy']; }

  /* ---------- background cut-out ----------
     Printify photos sit on pure white. removeWhite() clears the white that touches the edges
     (plus big enclosed white gaps, e.g. between an arm and the body), drops JPEG specks, and
     softens a 3px edge so dark shirts don't get a white outline. For flat-shirt photos
     (shadow = true) the mockup's grey drop shadow becomes a soft see-through shadow.
     CX.cutout(url, shadow) returns a
     promise of a transparent image URL (cached). Callers fall back to the photo if it fails. */
  function removeWhite(px, w, h, shadow) {
    var N = w * h, i, x, y;
    var mn = new Uint8Array(N), mx = new Uint8Array(N);
    for (i = 0; i < N; i++) {
      var r = px[i * 4], g = px[i * 4 + 1], b = px[i * 4 + 2];
      mn[i] = r < g ? (r < b ? r : b) : (g < b ? g : b);
      mx[i] = r > g ? (r > b ? r : b) : (g > b ? g : b);
    }
    var st = new Uint8Array(N);              // 1 = background
    var q = new Int32Array(N), qh = 0, qt = 0;
    var T = 248;
    // flat-shirt photos have a soft grey drop shadow around the shirt. Light neutral greys that are
    // clearly lighter than the shirt fabric (sampled beside the print) count as shadow, not shirt.
    // White shirts are never touched: for them the limit is above 255.
    var SV = 256;
    if (shadow) {
      var fr = 0, fc = 0, cx0 = Math.round(w * .34), cy0 = Math.round(h * .56);
      for (var sy = -4; sy <= 4; sy++) for (var sx = -4; sx <= 4; sx++) { fr += mn[(cy0 + sy) * w + cx0 + sx]; fc++; }
      SV = Math.max(fr / fc + 18, 200);
    }
    function push(j) { if (!st[j] && (mn[j] >= T || (mn[j] >= SV && mx[j] - mn[j] <= 14))) { st[j] = 1; q[qt++] = j; } }
    for (x = 0; x < w; x++) { push(x); push((h - 1) * w + x); }
    for (y = 0; y < h; y++) { push(y * w); push(y * w + w - 1); }
    while (qh < qt) {
      i = q[qh++]; x = i % w; y = (i / w) | 0;
      if (x > 0) push(i - 1); if (x < w - 1) push(i + 1); if (y > 0) push(i - w); if (y < h - 1) push(i + w);
    }
    // enclosed white gaps: big connected areas of near-pure white the border fill couldn't reach
    var seen = new Uint8Array(N), minArea = Math.max(80, Math.round(N * 0.0005));
    for (var s = 0; s < N; s++) {
      if (st[s] || seen[s] || mn[s] < 252) continue;
      qh = 0; qt = 0; q[qt++] = s; seen[s] = 1;
      while (qh < qt) {
        i = q[qh++]; x = i % w; y = (i / w) | 0;
        var nb = [x > 0 ? i - 1 : -1, x < w - 1 ? i + 1 : -1, y > 0 ? i - w : -1, y < h - 1 ? i + w : -1];
        for (var k = 0; k < 4; k++) { var j = nb[k]; if (j > -1 && !seen[j] && !st[j] && mn[j] >= 250) { seen[j] = 1; q[qt++] = j; } }
      }
      if (qt >= minArea) for (k = 0; k < qt; k++) st[q[k]] = 1;
    }
    // drop tiny specks: small foreground islands floating in the background (JPEG noise)
    var seen2 = new Uint8Array(N), minIsland = Math.max(8, Math.round(N * 0.00004));
    for (var s2 = 0; s2 < N; s2++) {
      if (st[s2] || seen2[s2]) continue;
      qh = 0; qt = 0; q[qt++] = s2; seen2[s2] = 1;
      while (qh < qt) {
        i = q[qh++]; x = i % w; y = (i / w) | 0;
        var n2 = [x > 0 ? i - 1 : -1, x < w - 1 ? i + 1 : -1, y > 0 ? i - w : -1, y < h - 1 ? i + w : -1];
        for (var k2 = 0; k2 < 4; k2++) { var j2 = n2[k2]; if (j2 > -1 && !seen2[j2] && !st[j2]) { seen2[j2] = 1; q[qt++] = j2; } }
      }
      if (qt < minIsland) for (k2 = 0; k2 < qt; k2++) st[q[k2]] = 1;
    }
    // distance (in px, up to 4) from the background, for the soft edge band
    var dist = new Uint8Array(N); qh = 0; qt = 0;
    for (i = 0; i < N; i++) { if (st[i]) { dist[i] = 0; } else { dist[i] = 255; } }
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; if (st[i]) continue;
      if ((x > 0 && st[i - 1]) || (x < w - 1 && st[i + 1]) || (y > 0 && st[i - w]) || (y < h - 1 && st[i + w])) { dist[i] = 1; q[qt++] = i; }
    }
    while (qh < qt) {
      i = q[qh++]; if (dist[i] >= 4) continue; x = i % w; y = (i / w) | 0;
      var nn = [x > 0 ? i - 1 : -1, x < w - 1 ? i + 1 : -1, y > 0 ? i - w : -1, y < h - 1 ? i + w : -1];
      for (var m = 0; m < 4; m++) { var jn = nn[m]; if (jn > -1 && dist[jn] === 255) { dist[jn] = dist[i] + 1; q[qt++] = jn; } }
    }
    // background goes clear; in shadow mode the grey turns into a soft see-through shadow
    for (i = 0; i < N; i++) if (st[i]) {
      if (shadow && mn[i] < 252) {
        var v = (px[i * 4] + px[i * 4 + 1] + px[i * 4 + 2]) / 3;
        px[i * 4] = px[i * 4 + 1] = px[i * 4 + 2] = 0;
        px[i * 4 + 3] = Math.round(Math.min(.42, (255 - v) / 255 * 1.6) * 255);
      } else px[i * 4 + 3] = 0;
    }
    // soft matte on the 3px band: each band pixel = solid colour (from the pixels just inside) mixed with white
    var BAND = 3, R = 4;
    for (y = 0; y < h; y++) for (x = 0; x < w; x++) {
      i = y * w + x; if (st[i] || dist[i] > BAND) continue;
      var fr = 0, fg = 0, fb = 0, n = 0;
      for (var dy = -R; dy <= R; dy++) for (var dx = -R; dx <= R; dx++) {
        var xx = x + dx, yy = y + dy; if (xx < 0 || yy < 0 || xx >= w || yy >= h) continue;
        var jj = yy * w + xx; if (st[jj] || dist[jj] <= BAND) continue;
        fr += px[jj * 4]; fg += px[jj * 4 + 1]; fb += px[jj * 4 + 2]; n++;
      }
      if (!n) { px[i * 4 + 3] = Math.round(255 * Math.min(1, Math.max(0, (255 - mn[i]) / 110))); continue; }
      fr /= n; fg /= n; fb /= n;
      var c = [px[i * 4], px[i * 4 + 1], px[i * 4 + 2]], F = [fr, fg, fb];
      var kk = 0; for (var t = 1; t < 3; t++) if (255 - F[t] > 255 - F[kk]) kk = t;
      var span = 255 - F[kk];
      if (span < 12) { if (dist[i] === 1) px[i * 4 + 3] = 200; continue; }
      var a = Math.max(0, Math.min(1, (255 - c[kk]) / span));
      if (a > 0.02) for (t = 0; t < 3; t++) px[i * 4 + t] = Math.max(0, Math.min(255, Math.round((c[t] - (1 - a) * 255) / a)));
      px[i * 4 + 3] = Math.round(a * 255);
    }
    return px;
  }
  var cutCache = {}, cutOrder = [];
  function cutout(url, shadow) {
    if (!url) return Promise.reject(new Error('no url'));
    var key = (shadow ? 's|' : 'p|') + url;
    if (cutCache[key]) return cutCache[key];
    var p = new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth, h = im.naturalHeight;
          var cv = document.createElement('canvas'); cv.width = w; cv.height = h;
          var ctx = cv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0);
          var d = ctx.getImageData(0, 0, w, h);
          removeWhite(d.data, w, h, shadow);
          ctx.putImageData(d, 0, 0);
          cv.toBlob(function (bl) { bl ? resolve(URL.createObjectURL(bl)) : reject(new Error('encode')); }, 'image/webp', 0.9);
        } catch (err) { reject(err); }
      };
      im.onerror = function () { reject(new Error('load')); };
      im.src = (url.indexOf('//') === 0 ? location.protocol : '') + url;
    });
    cutCache[key] = p; cutOrder.push(key);
    if (cutOrder.length > 48) {
      var old = cutOrder.shift(), op = cutCache[old]; delete cutCache[old];
      op && op.then(function (u) { setTimeout(function () { URL.revokeObjectURL(u); }, 60000); }, function () {});
    }
    return p;
  }

  /* ---------- the shopper's size, remembered while they shop (Max, Oct 9 2026: "she already chose it") ----------
     One size per group: kids, toddler, women and men (adult tees seen from the Women / Men side) and adult (no side;
     also the fallback for women / men). The shop filter's Size and any size picked on a product page save it; a
     product page then opens on it when that size is made in the colour shown. Kept 12 hours in this browser.
     Storage can be blocked (private windows): then nothing is remembered and everything still works. */
  var SIZE_TTL = 12 * 3600 * 1000;
  function sizeKey(who, side) {
    if (who === 'adult') return side === 'women' || side === 'her' ? 'women' : side === 'men' || side === 'him' ? 'men' : 'adult';
    return who === 'toddler' ? 'toddler' : 'kids';
  }
  function sizeRead(key) {
    try {
      var raw = localStorage.getItem('cx-size:' + key); if (!raw) return '';
      var o = JSON.parse(raw);
      if (!o || !o.s || Date.now() - (+o.t || 0) > SIZE_TTL) { localStorage.removeItem('cx-size:' + key); return ''; }
      return String(o.s);
    } catch (e) { return ''; }
  }
  function sizeWrite(key, value) {
    try {
      if (value) localStorage.setItem('cx-size:' + key, JSON.stringify({ s: value, t: Date.now() }));
      else localStorage.removeItem('cx-size:' + key);
    } catch (e) { }
  }
  /* sizePref(key) reads, sizePref(key, 'XL') saves, sizePref(key, '') forgets */
  function sizePref(key, value) {
    if (value === undefined) return sizeRead(key) || (key === 'women' || key === 'men' ? sizeRead('adult') : '');
    sizeWrite(key, value);
    if (key === 'women' || key === 'men') sizeWrite('adult', value);
    return value;
  }

  window.CX = { money: money, esc: esc, sized: sized, cart: cart, refresh: refresh, open: openCart, close: closeCart, add: addAndOpen, addMany: addManyAndOpen, toast: toast, picker: picker, view: view, photos: photos, modelLabels: modelLabels, cutout: cutout, see: see, cardColor: cardColor, paintCard: paintCard, HEX: HEX, sizeKey: sizeKey, sizePref: sizePref, styleProps: styleProps };
  document.dispatchEvent(new CustomEvent('cx:ready'));

  /* keep every link inside the concept: add ?view=<concept> to internal shop links */
  if (cview) {
    $$('a[href^="/"]').forEach(function (a) {
      var h = a.getAttribute('href');
      if (/^\/(products|collections|pages|search)?(\/|\?|#|$)/.test(h) && h.indexOf('view=') < 0 && !a.hasAttribute('data-cx-raw')) {
        var hashAt = h.indexOf('#'), hash = hashAt > -1 ? h.slice(hashAt) : '', base = hashAt > -1 ? h.slice(0, hashAt) : h;
        a.setAttribute('href', base + (base.indexOf('?') > -1 ? '&' : '?') + 'view=' + cview + hash);
      }
    });
  }

  $$('[data-cx-card]').forEach(quickSync);
  refresh();
})();
